// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__99pfY","clickableRoot":"Card_clickableRoot__5RHw_"};